define('lib/backbone/Backbone.Mixins.Transport.Rails',['require','underscore','lib/backbone/Backbone.PodioOverrides','backbone','lib/Podio.Transport'],function (require) {

  var _ = require('underscore');
  require('lib/backbone/Backbone.PodioOverrides');
  var Backbone = require('backbone');
  var transport = require('lib/Podio.Transport');

  return {
    request: function(method, url, data, options) {
      method = method.toLowerCase();

      options = options || {};
      options.ajaxParams = {
        contentType: 'application/json'
      };

      if (method === 'get') {
        options.requestData = data;
      } else {
        options.ajaxParams.processData = false;
        options.requestData = JSON.stringify(data);
      }

      return transport[method+'JSON'](url, options);
    },

    sync: function(method, model, options) {
      options = options || {};
      var self = this;
      var promise, originalSuccess;

      // remove after the Rails error handling tech project is done:
      // https://podio.com/podio/development/apps/techprojects/items/284
      originalSuccess = options.success;
      options.success = function(resp) {
        if (resp.status && resp.status === 'error') {
          if (_.isFunction(options.error)) {
            options.error(resp);
          }
        } else {
          if (_.isFunction(originalSuccess)) {
            originalSuccess(resp);
          }
        }
      };
      // end

      if (this instanceof Backbone.Collection) {
        promise = Backbone.Collection.prototype.sync.apply(this, _.toArray(arguments));
      } else {
        promise = Backbone.Model.prototype.sync.apply(this, _.toArray(arguments));
      }

      promise.done(function(resp) {
        if (resp.status && resp.status == 'error' && resp.message) {
          self.trigger('podioError', resp.message, resp, model, options);
        }
      });

      this.lastPromise = promise;

      return promise;
    }
  };
});

